import { Button } from '@eventbrite/eds-button';
import classnames from 'classnames';
import React from 'react';
import './FilterButton.scss';

interface FilterButtonProps {
    onClick: Function;
    children: React.ReactElement<any, any>;
    value?: string;
    isActive?: boolean;
    isMobile?: boolean;
}

export const FilterButton = (props: FilterButtonProps) => {
    return (
        <Button
            data-testid={`filter-section-button-${props.value}`}
            style="none"
            __containerClassName={classnames(
                'filter-section__button',
                `filter-section__button-${
                    props.isActive ? 'selected' : 'unselected'
                }`,
                {
                    'filter-section__button--mobile': props.isMobile,
                },
            )}
            onClick={props.onClick}
        >
            {props.children}
        </Button>
    );
};

export default FilterButton;
